export type QueryValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | readonly (string | number)[];

export function qs(params: Record<string, QueryValue>): string {
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined || value === '') continue;
    if (Array.isArray(value)) {
      for (const item of value) sp.append(`${key}[]`, String(item));
      continue;
    }
    sp.set(key, String(value));
  }
  return sp.toString();
}

export function withQuery(path: string, params: Record<string, QueryValue>): string {
  const query = qs(params);
  return query ? `${path}?${query}` : path;
}
